import { fork } from 'redux-saga/effects';

import commonSaga from 'modules/common/sagas';
import generalSaga from 'modules/general/sagas';
import postsSaga from 'modules/posts/sagas';
import doctorsSaga from 'modules/doctors/sagas';
import companiesSaga from 'modules/companies/sagas';
import companyActivationSaga from 'modules/companyActivation/sagas';
import circlesSaga from 'modules/circles/sagas';
import profilesSaga from 'modules/profiles/sagas';

function* rootSaga() {
  yield fork(commonSaga);
  yield fork(generalSaga);
  yield fork(postsSaga);
  yield fork(doctorsSaga);
  yield fork(companiesSaga);
  yield fork(companyActivationSaga);
  yield fork(circlesSaga);
  yield fork(profilesSaga);
}

export default rootSaga;
